"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = install;
var _vueFragment = _interopRequireDefault(require("vue-fragment"));
/**
 * 注册全局插件
 * @param {*} Vue
 * @param {*} options
 */

// 用于减少无用的容器节点
// 如：<div><span v-if="status==1">正常</span><span v-else>异常</span></div>
// <fragment>这里是具体内容</fragment>

function install(Vue, options) {
  if (install.installed) {
    return;
  }
  Vue.use(_vueFragment.default.Plugin);
  require.context('@/plugins', true, /\.js$/).keys()
  // ignore current file
  .filter(key => !key.endsWith('./index.js')).forEach(async key => {
    const {
      default: plugin
    } = require(`@/plugins${key.substring(1)}`);
    Vue.use(plugin, options);
  });
}